import { Link } from "react-router-dom";
import config from "@/config";

/**
 * Static routes configuration for sitemap generation
 */
/**
 * Retired from user-facing sitemap (routes 301 → /).
 * Components and screens remain on disk for dormant Classic internals.
 */
const RETIRED_SITEMAP_ROUTES = [
    { path: "/", title: "Choose Game", description: "Select from our real estate games" },
    { path: "/classic", title: "Classic Game", description: "Guess property prices in the classic mode" },
    { path: "/puzzle", title: "Daily Puzzle", description: "Play the daily real estate puzzle" },
    { path: "/social", title: "Social Mode", description: "Share and compete with friends" },
    { path: "/classic/faq", title: "FAQ - Classic", description: "Frequently asked questions about Classic mode" },
    { path: "/faq", title: "FAQ", description: "Frequently asked questions about PriceMe" },
];

const SITEMAP_ROUTES = [
    {
        path: "/",
        title: "Feed",
        description: "Scroll through spectacular homes and guess the prices",
    },
    {
        path: "/leaderboard",
        title: "Leaderboard",
        description: "Track your score distribution",
    },
    { path: "/about", title: "About", description: "Learn about PriceMe" },
    // { path: "/faq", title: "FAQ", description: "Frequently asked questions about PriceMe" },
    { path: "/terms-of-service", title: "Terms of Service", description: "Terms and conditions" },
    { path: "/privacy-policy", title: "Privacy Policy", description: "Privacy policy and data handling" },
    { path: "/credits", title: "Credits", description: "Asset credits and attributions" },
    { path: "/contact", title: "Contact Us", description: "Get in touch with the PriceMe team" },
];

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const _retiredSitemapRoutes = RETIRED_SITEMAP_ROUTES;

/**
 * Sitemap page component displaying all available routes
 */
const Sitemap = () => {
    return (
        <>
            <div className="container py-5">
                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <h1 className="mb-4">Sitemap</h1>
                        <p className="lead mb-4">Find all pages and sections available on PriceMe</p>

                        <div className="list-group">
                            {SITEMAP_ROUTES.map((route) => (
                                <Link
                                    key={route.path}
                                    to={route.path}
                                    className="list-group-item list-group-item-action"
                                >
                                    <div className="d-flex w-100 justify-content-between">
                                        <h5 className="mb-1">{route.title}</h5>
                                        <small className="text-muted">{route.path}</small>
                                    </div>
                                    <p className="mb-1">{route.description}</p>
                                    <small className="text-muted">
                                        {config.BASE_URL}
                                        {route.path}
                                    </small>
                                </Link>
                            ))}
                        </div>

                        {/*
                        <div className="mt-4">
                            <h3>Game Variations</h3>
                            <ul className="list-unstyled">
                                <li>• Classic - Traditional property price guessing</li>
                                <li>• Puzzle - Daily challenge with unique properties</li>
                                <li>• Social - Share results and compete with friends</li>
                            </ul>
                        </div>
                        */}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Sitemap;
